module.exports = __webpack_public_path__ + "img/PM_A02_front_cross_horizontal_en.e2c7c908.png";